import { IAlertModalContents } from '@components/modal/AlertModal';
import { atom } from 'recoil';

export const alertModalState = atom<IAlertModalContents>({
  key: 'alertModalState',
  default: {
    open: false,
    title: '',
    content: '',
    confirmBtnValue: '',
    handleConfirmClick: () => {},
  },
});
